module.exports = __webpack_public_path__ + "img/slide1.4bcbc2ee.gif";